// extracted by mini-css-extract-plugin
module.exports = {"header":"header-1laA1","title":"title-cz2YM","icon":"icon-Pt0_r","closed":"closed-DNRKQ","content":"content-93Rls"};